module.exports = __webpack_public_path__ + "static/media/robo3.42a2392b.png";